module.exports = __webpack_public_path__ + "img/nps.36845ca0.png";